import { Trans } from '@lingui/react/macro';

import styles from './GenericInfo.module.css';
import { useCurrentStep } from '../../../hooks/useCurrentStep';
import useWindowDimensions from '../../../hooks/useWindowDimensions';
import Help from '../Help/Help';

export const GenericInfo = () => {
  const currentStep = useCurrentStep();
  const { isMobile } = useWindowDimensions();

  const isDocsRequiredStepDE =
    currentStep === 'eignungscheck' || currentStep === 'schritt-3';

  return (
    <>
      <h2 className={styles.heading}>
        <Trans>Get a fast, flexible loan on your terms</Trans>
      </h2>
      <div className={styles.completionSteps}>
        <h3 className={styles.stepsHeading}>
          <Trans>How does it work?</Trans>
        </h3>
        <ol className={styles.stepsList}>
          {!isDocsRequiredStepDE ? (
            <li>
              <Trans>Tell us about your business.</Trans>
            </li>
          ) : (
            <li>
              <Trans>Upload your documents.</Trans>
            </li>
          )}
          <li>
            <Trans>Get a decision and receive multiple funding offers.</Trans>
          </li>
          <li>
            <Trans>
              Once you accept an offer, you will receive funds within 24 hours.
            </Trans>
          </li>
        </ol>
      </div>
      {!isMobile && <Help />}
    </>
  );
};
